import { publicResourceManager } from "../../constants/apis/apiEndpoints";
import axiosInstance from "../../translator";

export const fetchCloudVMList = async (urlParams = "") => {
  return axiosInstance
    .get(`${publicResourceManager?.cloud_vm_list}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const cloudVMOperationApi = async (data) => {
  return axiosInstance
    .patch(`${publicResourceManager?.cloudVM}/${data?.id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const cloudProviderAzureListApi = async (urlParams = "") => {
  return axiosInstance
    .get(`${publicResourceManager?.cloudProviderAzureList}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchAzureResourceApi = async (url, params = "") => {
  return axiosInstance
    .get(`${url}${params}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchAzureInstanceSizesApi = async (urlParams = "") => {
  return axiosInstance
    .get(`${publicResourceManager?.azureInstanceSizes}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const listAzureVmTemplatesApi = async (params = "") => {
  return axiosInstance
    .get(`${publicResourceManager?.azureVmTemplates}${params}`)
    .then((response) => response)
    .catch((error) => error);
};

export const createAzureVmTemplateApi = async (providerId, data) => {
  return axiosInstance
    .post(`${publicResourceManager?.azureVmTemplates}?provider_id=${providerId}`, data)
    .then((response) => response)
    .catch((error) => error);
};

export const updateAzureVmTemplateApi = async (providerId, templateName, data) => {
  return axiosInstance
    .put(
      `${publicResourceManager?.azureVmTemplateUpdate}?provider_id=${providerId}&template_name=${encodeURIComponent(templateName)}`,
      data
    )
    .then((response) => response)
    .catch((error) => error);
};

export const fetchAzureVmTemplateApi = async (providerId, templateId) => {
  return axiosInstance
    .get(
      `${publicResourceManager?.azureVmTemplateById}?provider_id=${providerId}&template_id=${templateId}`
    )
    .then((response) => response)
    .catch((error) => error);
};

export const deleteAzureVmTemplateApi = async (providerId, templateName) => {
  return axiosInstance
    .delete(
      `${publicResourceManager?.azureVmTemplateUpdate}?provider_id=${providerId}&template_name=${encodeURIComponent(templateName)}`
    )
    .then((response) => response)
    .catch((error) => error);
};

export const publishAzureVmTemplateApi = async (data) => {
  return axiosInstance
    .post(`${publicResourceManager?.azureVmSkuPublish}`, data)
    .then((response) => response)
    .catch((error) => error);
};

export const listAzureSkusApi = async (params = "") => {
  return axiosInstance
    .get(`/v1/public/azure/image-catalog/template-skus${params}`)
    .then((response) => response)
    .catch((error) => error);
};

export const createAzureSkuApi = async (data) => {
  return axiosInstance
    .post(`/v1/public/azure/image-catalog/sku`, data)
    .then((response) => response)
    .catch((error) => error);
};

export const updateAzureSkuApi = async (skuId, data) => {
  return axiosInstance
    .put(`/v1/public/azure/image-catalog/sku?sku_id=${skuId}`, data)
    .then((response) => response)
    .catch((error) => error);
};
